import AbstractAlert from "./AbstractAlert.js";

/**
 * An alert representing a problem the user can ignore.
 */
export default class WarningAlert extends AbstractAlert {
	isWarning() {
		return true;
	}
}
